var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7 6.23858 7 9V11.9472C7 11.9966 6.98539 12.0448 6.95801 12.0859L5.25488 14.6406C5.08868 14.8899 5 15.1828 5 15.4824C5 16.3206 5.67945 17 6.51759 17H17.4824C18.3206 17 19 16.3206 19 15.4824C19 15.1828 18.9113 14.8899 18.7451 14.6406L17.042 12.0859C17.0146 12.0448 17 11.9966 17 11.9472V9C17 6.23858 14.7614 4 12 4ZM8.5 9C8.5 7.067 10.067 5.5 12 5.5C13.933 5.5 15.5 7.067 15.5 9V11.9472C15.5 12.2927 15.6023 12.6305 15.7939 12.9179L17.497 15.4726C17.499 15.4755 17.5 15.4789 17.5 15.4824C17.5 15.4847 17.4995 15.4873 17.4995 15.4873L17.4989 15.489C17.4989 15.489 17.497 15.4927 17.4948 15.4948C17.4927 15.497 17.489 15.4989 17.489 15.4989C17.489 15.4989 17.4862 15.5 17.4824 15.5H6.51759C6.51378 15.5 6.51097 15.4989 6.51097 15.4989C6.51097 15.4989 6.50729 15.497 6.50515 15.4948C6.50302 15.4927 6.50107 15.489 6.50107 15.489C6.50107 15.489 6.5 15.4862 6.5 15.4824C6.5 15.4789 6.50103 15.4755 6.50295 15.4726L8.20609 12.9179C8.39773 12.6305 8.5 12.2927 8.5 11.9472V9Z",
    fill: "#496492"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9846 18.2495C13.8618 19.2363 13.0201 20 12 20C10.9799 20 10.1382 19.2363 10.0154 18.2495C9.99835 18.1125 10.1119 18 10.25 18H13.75C13.8881 18 14.0016 18.1125 13.9846 18.2495Z",
    fill: "#496492"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.281e86ad8e3775b808a288db3f987a5d.svg";
export { ForwardRef as ReactComponent };